import Detail from './index.vue'
export default [{
    path: '/adwordsDetail',
    name:'adwordsDetail',
    component:Detail,
}]